import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthContext';
import { GradingSystemProvider } from './context/GradingSystemContext';
import { DisciplineSystemProvider } from './context/DisciplineSystemContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthProvider>
    <GradingSystemProvider>
      <DisciplineSystemProvider>
        <App />
      </DisciplineSystemProvider>
    </GradingSystemProvider>
  </AuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
